(() => {
  const storageKey = 'tournesols:wishlist:v1';

  const readWishlist = () => {
    try {
      const storedValue = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return new Set(Array.isArray(storedValue) ? storedValue : []);
    } catch (error) {
      return new Set();
    }
  };

  const writeWishlist = (wishlist) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(Array.from(wishlist)));
    } catch (error) {
      // The visual toggle still works when private browsing blocks storage.
    }
  };

  const updateButton = (button, isActive) => {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
    button.setAttribute('aria-label', isActive ? button.dataset.labelRemove : button.dataset.labelAdd);

    const icon = button.querySelector('span');

    if (icon) {
      icon.textContent = isActive ? '♥' : '♡';
    }
  };

  const syncButtons = (root = document) => {
    const wishlist = readWishlist();

    root.querySelectorAll('[data-tournesols-wishlist]').forEach((button) => {
      updateButton(button, wishlist.has(button.dataset.productHandle));
    });
  };

  if (window.TournesolsWishlist) {
    window.TournesolsWishlist.sync(document);
    return;
  }

  window.TournesolsWishlist = { sync: syncButtons };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tournesols-wishlist]');

    if (!button) {
      return;
    }

    event.preventDefault();

    const productHandle = button.dataset.productHandle;
    const wishlist = readWishlist();

    if (wishlist.has(productHandle)) {
      wishlist.delete(productHandle);
    } else {
      wishlist.add(productHandle);
    }

    writeWishlist(wishlist);

    document.querySelectorAll('[data-tournesols-wishlist]').forEach((wishlistButton) => {
      updateButton(wishlistButton, wishlist.has(wishlistButton.dataset.productHandle));
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    syncButtons(event.target);
  });

  window.addEventListener('storage', () => {
    syncButtons(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncButtons(document), { once: true });
  } else {
    syncButtons(document);
  }
})();
